import api from "@/lib/axiosConfig";
import { z } from "zod";
import { baseRoute } from "./writing";

export const writingSchema = z.object({
  id: z.string().optional(),
  ecritsDescriptionNumeroEnregistrement: z
    .string()
    .nonempty("form.error.emptyField"),
  ecritsDescriptionTitre: z.string(),
});

export const appendNoDuplicateRecordNumberRefine = <
  T extends {
    id?: string;
    ecritsDescriptionNumeroEnregistrement: string;
  },
>(
  schema: z.ZodType<T>,
) =>
  schema.refine(
    async (val) =>
      await validateNoDuplicateRecordNumbers(
        val.ecritsDescriptionNumeroEnregistrement,
        val.id,
      )
        .then(() => true)
        .catch(() => false),
    {
      message: "form.error.writing.duplicateRecordNumbers",
      path: ["ecritsDescriptionNumeroEnregistrement"],
    },
  );

export async function validateNoDuplicateRecordNumbers(
  recordNumber: string,
  id?: string,
) {
  await api.get<void>(`${baseRoute}/record-number/validate/no-duplicates`, {
    params: {
      value: recordNumber,
      id,
    },
  });
}
